export default function() {
    return {
        symplaToken: {
            name: '',
            token: ''
        },
        success: false,
        errors: {
            name: null,
            token: null
        }
    }
}
